import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
  output,
} from '@angular/core';
import { UiDayStripComponent } from '../../atoms/day-strip/day-strip.component';
import { UiIconTabBarComponent } from '../../atoms/icon-tab-bar/icon-tab-bar.component';
import { UiInputComponent } from '../../atoms/input/input.component';
import { UiTaskItemComponent } from '../../molecules/task-item/task-item.component';
import type { UiIconTab } from '../../atoms/icon-tab-bar/icon-tab-bar.component';
import type { UiTaskParticipant, UiTaskTag } from '../../molecules/task-item/task-item.component';

export type { UiIconTab, UiTaskParticipant, UiTaskTag };

export interface UiTaskItemData {
  id: string;
  title: string;
  timeRange?: string;
  participants?: readonly UiTaskParticipant[];
  platform?: string;
  tag?: UiTaskTag | null;
}

/**
 * Organismo: panel To-Do completo.
 * Compone: encabezado, carrusel de días, buscador, tab-bar e ítems de tarea.
 */
@Component({
  selector: 'ui-task-panel',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    UiDayStripComponent,
    UiIconTabBarComponent,
    UiInputComponent,
    UiTaskItemComponent,
  ],
  templateUrl: './task-panel.component.html',
  styleUrl: './task-panel.component.scss',
  host: { class: 'ui-task-panel-host' },
})
export class UiTaskPanelComponent {
  readonly title = input('Calendario');
  readonly selectedDate = input<Date | null>(null);
  readonly tabs = input<readonly UiIconTab[]>([]);
  readonly activeTab = input<string>('');
  readonly tasks = input<readonly UiTaskItemData[]>([]);

  /** Valor del buscador; soporta `[(searchValue)]` two-way binding */
  readonly searchValue = model('');

  readonly daySelect = output<Date>();
  readonly tabChange = output<string>();
  readonly taskClick = output<UiTaskItemData>();
  readonly seeAllClick = output<void>();
}
